module.exports = __webpack_public_path__ + "static/media/proj7_img3.803a98a8.jpg";